var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconParty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 17.45L3 33.5L19.05 27.815M6 5H6.015M33 12.5H33.015M22.5 3.5H22.515M33 30.5H33.015M33 3.5L29.64 4.625C28.6836 4.94358 27.8675 5.58446 27.3312 6.43809C26.795 7.29171 26.5719 8.30509 26.7 9.305C26.85 10.595 25.845 11.75 24.525 11.75H23.955C22.665 11.75 21.555 12.65 21.315 13.91L21 15.5M33 20L31.77 19.505C30.48 18.995 29.04 19.805 28.8 21.17C28.635 22.22 27.72 23 26.655 23H25.5M16.5 3.5L16.995 4.73C17.505 6.02 16.695 7.46 15.33 7.7C14.28 7.85 13.5 8.78 13.5 9.845V11",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5008 19.9998C19.3958 22.8948 20.7458 26.2548 19.5008 27.4998C18.2558 28.7448 14.8958 27.3948 12.0008 24.4998C9.10576 21.6048 7.75576 18.2448 9.00076 16.9998C10.2458 15.7548 13.6058 17.1048 16.5008 19.9998Z",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParty);
export default __webpack_public_path__ + "static/media/icon--party.2fe4ca98e1995edd5159286f0d1c08c9.svg";
export { ForwardRef as ReactComponent };